/**
 * teamCopy — single source of truth for adult vs youth labels.
 *
 * Adult-team copy swaps every "guardian/parent" surface to "player/team
 * member" so adult leagues don't feel like they're using a kid's app. Pass a
 * team object (with `team_type`) and pull the right labels from the returned
 * object. Components stay UI-only; this file owns the words.
 */

const YOUTH = {
  isAdult: false,
  rosterUnit: "Player",
  rosterUnitPlural: "Players",
  inviteeSingular: "Guardian",
  inviteeSingularLower: "guardian",
  inviteePlural: "Guardians",
  inviteePluralLower: "guardians",
  inviteeEmailLabel: "Guardian email",
  inviteeFirstNameLabel: "Guardian first name",
  inviteeLastNameLabel: "Guardian last name",
  inviteSentCopy: "We'll email the guardian a link to set up their Clipboard.",
  chalkTalkAudienceLabel: "Guardians",
  joinCtaCopy: "Join your child's team with a code",
};

const ADULT = {
  isAdult: true,
  rosterUnit: "Player",
  rosterUnitPlural: "Players",
  inviteeSingular: "Player",
  inviteeSingularLower: "player",
  inviteePlural: "Team members",
  inviteePluralLower: "team members",
  inviteeEmailLabel: "Player email",
  inviteeFirstNameLabel: "Player first name",
  inviteeLastNameLabel: "Player last name",
  inviteSentCopy: "We'll email the player a link to claim their spot.",
  chalkTalkAudienceLabel: "Team",
  joinCtaCopy: "Join your team with a code",
};

export function teamCopy(team) {
  if (team && team.team_type === "adult") return ADULT;
  return YOUTH;
}

// For pages that don't have a team in scope yet (signup, login) but want
// neutral language that works for both audiences.
export const NEUTRAL_COPY = {
  ...YOUTH,
  joinCtaCopy: "Join a team with a code",
};
